<template>
  <div class="d-flex">
    <zingchart
      :height="height"
      :width="width"
      :data="graph_data"
      :series="graph_series"
      :id="$options.name"
    ></zingchart>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "a-restaurant-sales-chart",
  props: {
    height: {
      type: String,
      Number,
      default: "100px"
    },
    width: {
      type: String,
      Number,
      default: "100%"
    },
    series: {
      type: Object,
      default: function() {
        return {};
      }
    },
    labels: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    graph_data() {
      let minY = 0;
      for (let serie in this.series) {
        if (this.series[serie].values.length > 0) {
          minY = Math.min(...this.series[serie].values);
        }
      }
      return {
        type: "area",
        globals: this.chart_settings.globals,
        crosshairX: this.chart_settings.crosshair_settings,
        gui: this.chart_settings.gui,
        backgroundColor: "none",
        plotarea: {
          margin: "5px"
        },
        plot: {
          barWidth: "12px",
          borderRadius: 10,
          borderWidth: "1px",
          borderColor: "#ffffff",
          aspect: "spline",
          stacked: false
        },
        tooltip: {
          visible: false
        },
        scaleX: {
          visible: false
        },
        scaleY: {
          minValue: minY,
          visible: false
        }
      };
    },
    graph_series() {
      let colors = ["#5489d0", "#edae10"];
      let i = 0;
      let series = [];
      for (let serie in this.series) {
        let color = colors[i];
        series.push({
          values: this.series[serie],
          backgroundColor: color,
          lineColor: color,
          marker: {
            visible: true,
            backgroundColor: "#fff",
            borderColor: color,
            borderWidth: 2,
            size: 4
          }
        });
        i++;
      }
      return series;
    },
    ...mapState({
      chart_settings: state => state.chart_settings
    })
  }
};
</script>
